import { render, staticRenderFns } from "./BackorderedNumberInfo.vue?vue&type=template&id=3758325e&scoped=true&"
import script from "./BackorderedNumberInfo.vue?vue&type=script&lang=ts&"
export * from "./BackorderedNumberInfo.vue?vue&type=script&lang=ts&"
import style0 from "./BackorderedNumberInfo.vue?vue&type=style&index=0&id=3758325e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3758325e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
